module.exports = __webpack_public_path__ + "assets/img/pic@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic@3x.png
// module id = 1974
// module chunks = 0